function TechStack(){
return(
<section>
<h2>Tecnologias</h2>

<div className="card-grid">

<div className="card">Java</div>
<div className="card">React</div>
<div className="card">JavaScript</div>
<div className="card">HTML</div>
<div className="card">CSS</div>
<div className="card">MySQL</div>

</div>

</section>
)
}

export default TechStack
